import { swaggerSplitApi as api } from "../swaggerApi"
import { EventId } from "@app/data/eventDetails/types";

import { DetailedEventInSearchDto } from "@app/data/tribeSwaggerApi";
import eventPhoto from "@app/data/avatarUrl";

const eventDetailsApiInject = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getEventDetails: build.query<DetailedEventInSearchDto, EventId>({
      query(arg){
        return `/api/v1/events/${arg}`
      },
      providesTags: (result)=>[{ type: 'Event', id: result?.event_id }],
      transformResponse: (res:DetailedEventInSearchDto):DetailedEventInSearchDto => {
        res.event_photo = res?.event_photo?.map(eventPhoto)
        return res
      },
    })
  })
})
export const  {useGetEventDetailsQuery} = eventDetailsApiInject